import { render, staticRenderFns } from "./UpdateUserModal.vue?vue&type=template&id=1f32bce8&"
import script from "./UpdateUserModal.vue?vue&type=script&lang=js&"
export * from "./UpdateUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports